import React from 'react';
import { AuthConsumer } from '../../Context/AuthContext';
import functions from '../functions';

export const RenderSecure=(props)=>{


    return(
        <AuthConsumer>
            {userProps=>{
                if(functions.findInObject(userProps.permissionLists, props.code))
                {
                    return <>{props.children}</>
                }else{
                    return <></>
                }
            }}
        </AuthConsumer>
    )

}
/**
 * Page-level version of RenderSecure, used by the accounting pages.
 *
 * Wrapping the whole page rather than a fragment: without the permission the
 * page renders nothing at all, so a URL typed directly by someone who should
 * not see accounting shows an empty page instead of its contents.
 */
export const withPageSecurity = (WrappedComponent, code) => (props) => (
  <RenderSecure code={code}>
    <WrappedComponent {...props} />
  </RenderSecure>
);
